import { WorkLogStatus } from '@klubovna/api-client';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WorkLogsState } from './work-logs.state';

export const selectWorkLogsState = createFeatureSelector<WorkLogsState>('adminWorkLogs');

export const selectAllWorkLogs = createSelector(
  selectWorkLogsState,
  (state) => state.workLogs,
);

export const selectWorkLogsLoading = createSelector(
  selectWorkLogsState,
  (state) => state.loading,
);

export const selectWorkLogsError = createSelector(
  selectWorkLogsState,
  (state) => state.error,
);

export const selectWorkLogsPagination = createSelector(
  selectWorkLogsState,
  (state) => state.pagination,
);

export const selectPendingWorkLogs = createSelector(
  selectAllWorkLogs,
  (workLogs) => workLogs.filter(wl => wl.status === WorkLogStatus.Pending),
);

export const selectApprovedWorkLogs = createSelector(
  selectAllWorkLogs,
  (workLogs) => workLogs.filter(wl => wl.status === WorkLogStatus.Approved),
);

export const selectRejectedWorkLogs = createSelector(
  selectAllWorkLogs,
  (workLogs) => workLogs.filter(wl => wl.status === WorkLogStatus.Rejected),
);

